<div class="status-legend" *ngIf="statusTone !== 'draft'">
  <span class="legend-item" [class.legend-item--inactive]="statusTone !== 'draft'"><span class="legend-dot legend-dot--draft"></span>Draft</span>
  <span class="legend-item" [class.legend-item--inactive]="statusTone !== 'sent'"><span class="legend-dot legend-dot--sent"></span>Sent</span>
  <span class="legend-item" [class.legend-item--inactive]="statusTone !== 'void'"><span class="legend-dot legend-dot--void"></span>Void</span>
  <span class="legend-item" [class.legend-item--inactive]="statusTone !== 'completed'"><span class="legend-dot legend-dot--completed"></span>Completed</span>
</div>
<div class="split-view">
  <div class="pane pane--pdf">
    <div *ngIf="pdfSource; else generatingPreview">        
      <ngx-extended-pdf-viewer
        *ngIf="!isGuideOpen"
        id="listViewer" 
        [src]="pdfSource" 
        useBrowserLocale="true"
        [zoom]="'80%'"
        [showPrintButton]="false"
        [showDownloadButton]="false"
        [showOpenFileButton]="false"
        [showRotateButton]="false"
        [showSecondaryToolbarButton]="false"
        [showDrawEditor]="false"
        [showTextEditor]="false"  
        [showStampEditor]="false"    
        [textLayer]="true"
        (pdfLoaded)="isPdfLoaded = true"
        (textLayerRendered)="onTextLayerRendered($event)">
      ></ngx-extended-pdf-viewer>      
    </div>
    <ng-template #generatingPreview>
      <div class="generating-preview">
          <mat-spinner diameter="30" color="primary"></mat-spinner>
          <p class="loading-text">{{ loaderText }}</p>
      </div>
    </ng-template>
  </div>

  <div class="pane pane--status" [ngClass]="'pane--status--' + statusTone">
    <div class="status-header">
        <span class="action-link" (click)="onBackToList()">
          <mat-icon>arrow_back</mat-icon>
          Back to list
        </span>
        <button *ngIf="isDraft" type="button" class="recipients-toggle"
          [class.recipients-toggle--active]="showRecipients"
          [attr.aria-pressed]="showRecipients"
          (click)="showRecipients = !showRecipients">
          <mat-icon>{{ showRecipients ? 'close' : 'group' }}</mat-icon>
          {{ showRecipients ? 'Close recipients' : 'Manage recipients' }}
        </button>
        <span *ngIf="!isDraft">
          <mat-icon class="action-icon" matTooltip="Docusign guide" (click)="openDocusignGuide()">info_outline</mat-icon>
          <mat-icon class="action-icon" (click)="onRefresh()" matTooltip="Refresh status">refresh</mat-icon>
        </span>
    </div>

    <div class="status-body" *ngIf="!isDraft; else editingMode">
      <app-agreements-recipient-status 
      [envelopeId] = "selectedRowData?.envelope_id"
      [appData] = "dataModel"
      [currentUser] = "selectedRowData?.currentUser"
      ></app-agreements-recipient-status>
    </div>
    <ng-template #editingMode>
      <app-agreement-content-update 
      (applicationChange)="onApplicationChanged($event)"
      [envelopeId] = "selectedRowData?.envelope_id"
      [application] = "selectedRowData?.application"
      [currentUser] = "selectedRowData?.currentUser"
      [showRecipients] = "showRecipients"
      [isDraftReady] = "!!pdfSource && isPdfLoaded"
      (recipientsClose)="showRecipients = false"
      ></app-agreement-content-update>
    </ng-template>
  </div>
</div>